import { allNigerianLGAs } from './allNigerianLGAs.js';

export const locations = [
  'Abia',
  'Adamawa',
  'Akwa Ibom',
  'Anambra',
  'Bauchi',
  'Bayelsa',
  'Benue',
  'Borno',
  'Cross River',
  'Delta',
  'Ebonyi',
  'Edo',
  'Ekiti',
  'Enugu',
  'Federal Capital Territory',
  'Gombe',
  'Imo',
  'Jigawa',
  'Kaduna',
  'Kano',
  'Katsina',
  'Kebbi',
  'Kogi',
  'Kwara',
  'Lagos',
  'Nasarawa',
  'Niger',
  'Ogun',
  'Ondo',
  'Osun',
  'Oyo',
  'Plateau',
  'Rivers',
  'Sokoto',
  'Taraba',
  'Yobe',
  'Zamfara',
];

/**
 * State Locations Map
 * Maps each state to comprehensive list of LGAs and major cities
 * Uses allNigerianLGAs database with fallback to formatted city names
 */
export const stateLocations = {
  Abia: allNigerianLGAs.Abia || ['Aba', 'Umuahia', 'Ohafia', 'Arochukwu', 'Umundiegwu'],
  Adamawa: allNigerianLGAs.Adamawa || ['Yola', 'Mubi', 'Jimeta', 'Numan', 'Ganye'],
  'Akwa Ibom': allNigerianLGAs['Akwa Ibom'] || ['Uyo', 'Eket', 'Ikot Ekpene', 'Oron', 'Abak'],
  Anambra: allNigerianLGAs.Anambra || ['Awka', 'Onitsha', 'Nnewi', 'Ekwulobia', 'Ogidi'],
  Bauchi: allNigerianLGAs.Bauchi || ['Bauchi', 'Azare', 'Misau', "Jama'are", 'Katagum'],
  Bayelsa: allNigerianLGAs.Bayelsa || ['Yenagoa', 'Brass', 'Ogbia', 'Sagbama', 'Ekeremor'],
  Benue: allNigerianLGAs.Benue || ['Makurdi', 'Gboko', 'Otukpo', 'Katsina-Ala', 'Vandeikya'],
  Borno: allNigerianLGAs.Borno || ['Maiduguri', 'Biu', 'Damboa', 'Monguno', 'Bama'],
  'Cross River': allNigerianLGAs['Cross River'] || ['Calabar', 'Ikom', 'Ogoja', 'Obudu', 'Ugep'],
  Delta: allNigerianLGAs.Delta || ['Asaba', 'Warri', 'Sapele', 'Ughelli', 'Agbor'],
  Ebonyi: allNigerianLGAs.Ebonyi || ['Abakaliki', 'Afikpo', 'Onueke', 'Ishielu', 'Ezza'],
  Edo: allNigerianLGAs.Edo || ['Benin City', 'Auchi', 'Ekpoma', 'Uromi', 'Irrua'],
  Ekiti: allNigerianLGAs.Ekiti || ['Ado-Ekiti', 'Ikere', 'Oye', 'Ijero', 'Ikole'],
  Enugu: allNigerianLGAs.Enugu || [
    'Enugu City',
    'Independence Layout',
    'GRA',
    'Nsukka',
    'Agbani',
    'Awgu',
    'Iwollo',
  ],
  'Federal Capital Territory': allNigerianLGAs['Federal Capital Territory'] || [
    'Maitama',
    'Asokoro',
    'Wuse',
    'Gwarinpa',
    'Jabi',
    'Kubwa',
    'Lugbe',
    'Lokogoma',
    'Abuja',
    'Gwagwalada',
  ],
  Gombe: allNigerianLGAs.Gombe || ['Gombe', 'Kaltungo', 'Billiri', 'Dukku', 'Bajoga'],
  Imo: allNigerianLGAs.Imo || ['Owerri', 'Orlu', 'Okigwe', 'Oguta', 'Mbaise'],
  Jigawa: allNigerianLGAs.Jigawa || ['Dutse', 'Hadejia', 'Gumel', 'Kazaure', 'Birnin Kudu'],
  Kaduna: allNigerianLGAs.Kaduna || [
    'Kaduna',
    'Zaria',
    'Kafanchan',
    'Kagoro',
    'Saminaka',
    'Kontagora',
  ],
  Kano: allNigerianLGAs.Kano || ['Kano', 'Wudil', 'Gwarzo', 'Rano', 'Bichi', 'Kumbotso'],
  Katsina: allNigerianLGAs.Katsina || ['Katsina', 'Daura', 'Funtua', 'Malumfashi', 'Dutsin-Ma'],
  Kebbi: allNigerianLGAs.Kebbi || ['Birnin Kebbi', 'Argungu', 'Yauri', 'Zuru', 'Jega'],
  Kogi: allNigerianLGAs.Kogi || ['Lokoja', 'Okene', 'Idah', 'Kabba', 'Anyigba'],
  Kwara: allNigerianLGAs.Kwara || ['Ilorin', 'Offa', 'Jebba', 'Lafiagi', 'Patigi'],
  Lagos: allNigerianLGAs.Lagos || [
    'Lekki',
    'Ikeja',
    'Yaba',
    'Surulere',
    'Ajah',
    'Ikoyi',
    'Victoria Island',
    'Ikorodu',
    'Gbagada',
    'Maryland',
    'Magodo',
    'Ojodu',
    'Agege',
    'Oshodi',
  ],
  Nasarawa: allNigerianLGAs.Nasarawa || ['Lafia', 'Keffi', 'Akwanga', 'Doma', 'Nasarawa'],
  Niger: allNigerianLGAs.Niger || ['Minna', 'Bida', 'Suleja', 'Kontagora', 'New Bussa'],
  Ogun: allNigerianLGAs.Ogun || ['Abeokuta', 'Ijebu Ode', 'Sagamu', 'Ota', 'Ilaro'],
  Ondo: allNigerianLGAs.Ondo || ['Akure', 'Ondo', 'Owo', 'Ikare', 'Ore'],
  Osun: allNigerianLGAs.Osun || ['Osogbo', 'Ile-Ife', 'Ilesa', 'Ede', 'Iwo'],
  Oyo: allNigerianLGAs.Oyo || [
    'Ibadan',
    'Ogbomosho',
    'Iseyin',
    'Oyo',
    'Saki',
    'Oluyole',
    'Surulere-Ibadan',
  ],
  Plateau: allNigerianLGAs.Plateau || ['Jos', 'Bukuru', 'Barkin Ladi', 'Pankshin', 'Shendam'],
  Rivers: allNigerianLGAs.Rivers || [
    'Port Harcourt',
    'Obio-Akpor',
    'Eleme',
    'Bonny',
    'Oyigbo',
    'Okrika',
  ],
  Sokoto: allNigerianLGAs.Sokoto || ['Sokoto', 'Tambuwal', 'Bodinga', 'Gwadabawa', 'Illela'],
  Taraba: allNigerianLGAs.Taraba || ['Jalingo', 'Wukari', 'Takum', 'Bali', 'Gembu'],
  Yobe: allNigerianLGAs.Yobe || ['Damaturu', 'Potiskum', 'Gashua', 'Nguru', 'Geidam'],
  Zamfara: allNigerianLGAs.Zamfara || ['Gusau', 'Kaura Namoda', 'Talata Mafara', 'Anka', 'Maru'],
};

/**
 * Property type definitions with listing-type visibility.
 * Each entry: [value, label, allowedListingTypes]
 */
export const propertyTypes = [
  ['Apartment', 'Apartment', ['rent', 'buy', 'short-let']],
  ['House', 'House', ['rent', 'buy', 'short-let']],
  ['Duplex', 'Duplex', ['rent', 'buy', 'short-let']],
  ['Bungalow', 'Bungalow', ['rent', 'buy']],
  ['Flat', 'Flat', ['rent', 'buy']],
  ['Room', 'Room', ['rent', 'short-let']],
  ['Terrace', 'Terrace', ['rent', 'buy']],
  ['Penthouse', 'Penthouse', ['rent', 'buy', 'short-let']],
  ['Land', 'Land / Plot', ['rent', 'buy']],
  ['Shop', 'Shop / Retail', ['rent', 'buy']],
  ['Commercial', 'Commercial (office, warehouse)', ['rent', 'buy']],
  ['Garage', 'Garage / Parking space', ['rent', 'buy']],
  ['Other', 'Other (specify below)', ['rent', 'buy', 'short-let']],
];

// Property types with no meaningful bedroom/bathroom count - kept in sync
// with the bedroom/bathroom fields' visibility on the list-property form.
export const PROPERTY_TYPES_WITHOUT_ROOMS = ['Land', 'Commercial', 'Garage', 'Shop'];

export const propertyHasRooms = (propertyType) =>
  !PROPERTY_TYPES_WITHOUT_ROOMS.includes(propertyType);

/**
 * Documents a seller can declare as available for a For Sale listing.
 * Advertiser-reported only - NaijaNest does not verify any of these, see
 * the disclaimer shown alongside them on the list-property form and the
 * property details page.
 */
export const PROPERTY_DOCUMENT_TYPES = [
  ['cofo', 'Certificate of Occupancy (C of O)'],
  ['deed_of_assignment', 'Deed of Assignment'],
  ['gazette', 'Gazette'],
  ['governors_consent', "Governor's Consent"],
  ['survey_plan', 'Registered Survey Plan'],
  ['allocation_letter', 'Allocation Letter'],
  ['deed_of_conveyance', 'Deed of Conveyance'],
  ['other', 'Other'],
];

export const placeholderImage =
  'https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&w=1200&q=80';

export const filterOptionDefinitions = [
  ['filterFurnished', 'Furnished'],
  ['filterServiced', 'Serviced apartment'],
  ['filterSelfContained', 'Self-contained'],
  ['filterNewDevelopment', 'New development'],
  ['filterParking', 'Parking'],
  ['filterGated', 'Gated / Estate'],
  ['filterBoysQuarters', 'Boys quarters'],
  ['filterPrepaidMeter', 'Prepaid meter'],
  ['filterBorehole', 'Borehole / Water'],
  ['filterStudentFriendly', 'Student-friendly'],
  ['filterVerified', 'Verified only'],
  ['filterNoAgencyFee', 'No agency fee'],
  ['filterNearSchool', 'Near school'],
  ['filterNearMarket', 'Near market'],
  ['filterNearExpressway', 'Near expressway'],
  ['filterFloodFree', 'Flood-free area'],
];

/**
 * Form checkbox options with listing-type visibility.
 * Each entry: [key, label, allowedTypes]
 * allowedTypes is an array of listing types the checkbox applies to.
 * If omitted / empty, the checkbox shows for all types.
 */
export const formOptionDefinitions = [
  ['furnished', 'Furnished', ['rent', 'buy', 'short-let']],
  ['serviced', 'Serviced', ['rent', 'buy', 'short-let']],
  ['selfContained', 'Self-contained', ['rent', 'buy']],
  ['newDevelopment', 'New development', ['buy']],
  ['parking', 'Parking', ['rent', 'buy', 'short-let']],
  ['gated', 'Gated / Estate', ['rent', 'buy', 'short-let']],
  ['boysQuarters', 'Boys quarters', ['rent', 'buy']],
  ['prepaidMeter', 'Prepaid meter', ['rent', 'buy']],
  ['borehole', 'Borehole / Water', ['rent', 'buy']],
  ['studentFriendly', 'Student-friendly', ['rent']],
  ['noAgencyFee', 'No agency fee', ['rent']],
  ['nearSchool', 'Near school', ['rent', 'buy']],
  ['nearMarket', 'Near market', ['rent', 'buy']],
  ['nearExpressway', 'Near expressway', ['rent', 'buy', 'short-let']],
  ['floodFree', 'Flood-free area', ['rent', 'buy', 'short-let']],
];
